membershipService.$inject = [
  'jsSdk.user'
];

const MEMBERSHIP_LEVEL_MIN = 50;

const cities = [{
  id: '301072f4d252999a',
  slug: 'bos',
  name: 'Boston'
}, {
  id: 'aa211bf5d25100ac',
  slug: 'nyc',
  name: 'New York'
}, {
  id: '070ac346cd2d446f',
  slug: 'dc',
  name: 'D.C.'
}];

const venues = [{
  slug: 'royal',
  name: 'Royale',
  image: 'https://moth.imgix.net/data/CFA6-C9E4-E69F-f0c81194.jpg',
  city: 'bos',
  perks: ['preferred pricing', 'free entry']
}, {
  slug: 'storyville',
  name: 'Storyville',
  image: 'https://moth.imgix.net/d2/e2/d2e246d1-8adf2f62-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'bijou',
  name: 'Bijou',
  image: 'https://moth.imgix.net/data/7B33-A36F-FFEE-a9e4da4c.jpg',
  city: 'bos',
  perks: ['free entry', 'preferred pricing']
}, {
  slug: 'gem',
  name: 'Gem',
  image: 'https://moth.imgix.net/49/d4/49d4d96d-66c88e9c-IMG_7698.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'icon',
  name: 'ICON',
  image: 'https://images.tablelist.com/9a/87/9a87ed15-fd2f9c6b-large.jpg',
  city: 'bos',
  perks: ['free entry']
}, {
  slug: 'whiskysaigon',
  name: 'Whisky Saigon',
  image: 'https://moth.imgix.net/e0/d7/e0d7c71f-e871a716-1506138_213161352205296_1420796859_o.jpg',
  city: 'bos',
  perks: ['line jumpers', 'free entry']
}, {
  slug: 'alibi',
  name: 'Alibi',
  image: 'https://moth.imgix.net/cf/17/cf17f946-a72f9bb9-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
  // }, {
  //   slug: 'empire',
  //   name: 'Empire',
  //   image: 'https://moth.imgix.net/e3/1b/e31bf756-a618aaad-xlarge.jpg',
  //   city: 'bos',
  //   perks: [],
  // }, {
}, {
  slug: 'tunnel',
  name: 'Tunnel',
  image: 'https://moth.imgix.net/7a/27/7a277926-d7746303-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'marqueenyc',
  name: 'Marquee',
  image: 'https://moth.imgix.net/data/BD6D-E542-53E0-9e58ab6f.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'lavo',
  name: 'Lavo',
  image: 'https://moth.imgix.net/data/ABF7-3AAA-F02B-5e86b34a.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'tao',
  name: 'Tao',
  image: 'https://moth.imgix.net/data/2D3E-7527-8A92-aec3a3e9.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'flash',
  name: 'Flash Factory',
  image: 'https://moth.imgix.net/c12d9f38-0d02-dd67-7d509d91488b.png',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'bounce',
  name: 'Bounce',
  image: 'https://moth.imgix.net/data/2EC8-61F3-B20F-f8d66965.jpg',
  city: 'nyc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'hotelchantelle',
  name: 'Hotel Chantelle',
  image: 'https://moth.imgix.net/data/253C-357D-DDB9-5c076307.jpg',
  city: 'nyc',
  perks: ['line jumpers', 'table deals']
}, {
  slug: 'gansevoort',
  name: 'Gansevoort Park Ave',
  image: 'https://moth.imgix.net/cbc8ebad-b450-1da7-5f4e979eab97.jpg',
  city: 'nyc',
  perks: ['table deals']
}, {
  slug: 'gildedlily',
  name: 'Gilded Lily',
  image: 'https://moth.imgix.net/68/fa/68fa2155-c8150446-AG1424_Monarch_Shot2_Final.jpg',
  city: 'nyc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'living-room-dc',
  name: 'Living Room',
  image: 'https://moth.imgix.net/c65d0bf5-4623-d35c-b0d6f9bd2247.jpg',
  city: 'dc',
  perks: ['free entry']
}, {
  slug: 'capitale',
  name: 'Capitale',
  image: 'https://moth.imgix.net/data/9674-A457-E428-2723fad2.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'manor',
  name: 'Manor',
  image: 'https://moth.imgix.net/data/42DA-07BB-EE0B-071a306a.jpg',
  city: 'dc',
  perks: ['free entry', 'line jumpers']
}, {
  slug: 'heist1',
  name: 'Heist',
  image: 'https://moth.imgix.net/data/A9B0-5231-F4E4-5160e4b7.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'sax',
  name: 'Sax',
  image: 'https://moth.imgix.net/data/2355-A62B-7E02-d96d30fa.jpg',
  city: 'dc',
  perks: ['free entry', 'drink deals']
}, {
  slug: 'kabin',
  name: 'Kabin',
  image: 'https://moth.imgix.net/data/E752-77FA-49BD-39b15276.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals', 'drink deals']
}, {
  slug: 'flash',
  name: 'Flash',
  image: 'https://moth.imgix.net/data/B9D6-6945-E14D-c1941847.png',
  city: 'dc',
  perks: ['free entry']
}, {
  slug: 'provision14',
  name: 'Provision 14',
  image: 'https://moth.imgix.net/data/8C6D-CE08-1213-56be2154.jpeg',
  city: 'dc',
  perks: ['free entry', 'line jumpers', 'drink deals']
}];

const states = {
  CANCELLED: 'CANCELLED',
  ACTIVE: 'ACTIVE'
};

export default function membershipService(jsSdkUser) {
  class MembershipService {
    isUserSubscribed() { //eslint-disable-line
      const user = jsSdkUser.getCurrentUser();
      if (!user) return false;
      return user.membershipLevel >= MEMBERSHIP_LEVEL_MIN;
    }

    membershipLevel() { //eslint-disable-line
      const user = jsSdkUser.getCurrentUser();
      if (!user) return 0;
      return user.membershipLevel;
    }

    getCities() { //eslint-disable-line
      return cities;
    }

    getStates() { //eslint-disable-line
      return states;
    }

    getVenues() { //eslint-disable-line
      return venues;
    }

    getMinMembershipLevel() { //eslint-disable-line
      return MEMBERSHIP_LEVEL_MIN;
    }
  }

  return new MembershipService();
}



// WEBPACK FOOTER //
// ./src/services/membershipService.js